"use strict";

exports.__esModule = true;
exports.BLOG_COMMON_COMP_ID = void 0;
var BLOG_COMMON_COMP_ID = 'BLOG_COMMON';
exports.BLOG_COMMON_COMP_ID = BLOG_COMMON_COMP_ID;